export default "__VITE_ASSET__BfcVxHVL__"